import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(private readonly injector: Injector) {
    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
      const reason = event.reason;
      const error = reason instanceof Error ? reason : new Error(String(reason ?? 'Unhandled promise rejection'));
      this.appInsights?.trackException(error);
    });
  }

  handleError(error: unknown): void {
    // HttpErrorResponse is already caught and logged by HttpErrorInterceptor
    if (error instanceof HttpErrorResponse) return;

    const err = error instanceof Error ? error : new Error(String(error));
    this.appInsights?.trackException(err);
  }

  // Lazy getter avoids circular DI during bootstrap
  private get appInsights(): ApplicationInsightsService | null {
    return this.injector.get(ApplicationInsightsService, null);
  }
}
